export const ADD_ENTITY = "addentity";
export const RESET_ENTITY = "resetentity";
